export const FEE_CATEGORIES = {
  "rent": { defaultAmount: 0, frequency: 'Monthly' },
  "late charge": { defaultAmount: 125, frequency: 'One-Time' },
  "service of notice fee": { defaultAmount: 25, frequency: 'One-Time' },
  "eviction turnover": { defaultAmount: 50, frequency: 'One-Time' },
  "month to month fee": { defaultAmount: 200, frequency: 'One-Time' },
  "garage - attached": { defaultAmount: 0, frequency: 'Monthly' },
  "carport": { defaultAmount: 0, frequency: 'Monthly' },
  "storage space": { defaultAmount: 0, frequency: 'Monthly' },
  "pet fees & charges": { defaultAmount: 0, frequency: 'Monthly' },
  "insurance waiver": { defaultAmount: 0, frequency: 'Monthly' },
  "non-refundable fee": { defaultAmount: 0, frequency: 'One-Time' },
  "deposit paid in": { defaultAmount: 0, frequency: 'One-Time' },
  "miscellaneous income": { defaultAmount: 0, frequency: 'One-Time' },
  "media package": { defaultAmount: 0, frequency: 'Monthly' },
};

// Property ID that requires the Natural Hazard addendum (has creek running through it)
export const NATURAL_HAZARD_PROPERTY_ID = '4cbad654-d54e-40f8-bb3e-5927f94597ae';

export const ADDENDA_OPTIONS = [
  { label: 'Amenity Liability Waiver', value: 'amenity' },
  { label: 'Animal (Pet) Agreement', value: 'animal' },
  { label: 'Animal Identification Form', value: 'animal_identification' },
  { label: 'Community Policies', value: 'community' },
  { label: 'Concession Addendum', value: 'concession' },
  { label: 'Construction Addendum', value: 'construction' },
  { label: 'Garage Addendum', value: 'garage' },
  { label: 'Lease File Checklist', value: 'lease_file_checklist' },
  { label: 'Life Style Community Agreement', value: 'lifestyle_community_agreement' },
  { label: 'Media/Internet Addendum', value: 'media_internet_automation' },
  { label: 'Move-In/Out Inspection & Report', value: 'inspection_report' },
  { label: 'Natural Hazard', value: 'natural_hazard' },
  { label: 'Payment Addendum', value: 'payment' },
  { label: 'Spruce Lease', value: 'spruce' },
  { label: 'Smoke-Free Addendum', value: 'smoke_free' },
  { label: 'Social Media Addendum', value: 'social_media' },
  { label: 'Snow and Ice Removal Addendum', value: 'snow_ice' },
  { label: 'Utility Addendum', value: 'utility' },
];

export const ADDENDA_FIELDS = {
  animal: [
    { name: 'apa_animal_deposit', label: 'Animal Deposit Fee ($)', type: 'number' },
    { name: 'apa_animal_fee', label: 'Animal Fee ($)', type: 'number' },
    { name: 'apa_animal_monthly', label: 'Animal Monthly Fee ($)', type: 'number' },
    { name: 'apa_animal_name', label: 'Animal Name', type: 'text' },
    { name: 'apa_animal_type', label: 'Animal Type', type: 'text' },
    { name: 'apa_animal_color', label: 'Animal Color', type: 'text' },
    { name: 'apa_animal_age', label: 'Animal Age', type: 'number' },
    { name: 'apa_animal_license', label: 'Animal License Number', type: 'text' },
    { name: 'apa_animal_rabies', label: 'Date of Last Rabies Shot', type: 'date' },
    { name: 'apa_animal_breed', label: 'Animal Breed', type: 'text' },
    { name: 'apa_animal_weight', label: 'Animal Weight (lbs)', type: 'number' },
    { name: 'apa_animal_license_city', label: 'License City', type: 'text' },
    { name: 'apa_animal_owner_name', label: 'Owner Name', type: 'text' },
    { name: 'apa_animal_owner_email', label: 'Owner Email', type: 'email' },
    { name: 'apa_animal_veterinarian', label: 'Veterinarian Name', type: 'text' },
    { name: 'apa_animal_veterinarian_telephone', label: 'Veterinarian Telephone', type: 'text' },
    { name: 'apa_animal_emergency_contact', label: 'Emergency Contact Name', type: 'text' },
    { name: 'apa_animal_emergency_contact_cell', label: 'Emergency Contact Cell', type: 'text' },
  ],
  animal_identification: [
    { name: 'aif_animal_certificate', label: 'Animal Special Training/Certificate', type: 'text' },
    { name: 'aif_animal_reported', label: 'Has Animal Ever Been Reported for any incident? Yes or No.', type: 'text' },
    { name: 'aif_animal_reported_yes', label: 'If Yes, Provide Details', type: 'text' },
  ],
  garage: [
    { name: 'gra_assigned', label: 'Garage Assigned', type: 'text' },
    { name: 'gra_deposit', label: 'Garage Deposit', type: 'number' },
  ],
  media_internet_automation: [
    { name: 'mia_service_fee', label: 'Service Fee', type: 'number' },
  ],
  social_media: [
    { name: 'email', label: 'Resident Email', type: 'text' },
    { name: 'name_url', label: 'Resident Facebook Username or URL', type: 'text' },
    { name: 'cell_number', label: 'Resident Cellular Number', type: 'text' }
  ]
} as const;

export const DENIAL_REASONS = {
  // Credit-related (TransUnion)
  POOR_CREDIT: {
    code: "POOR_CREDIT",
    label: "Poor Credit Score",
    category: "Credit",
    description: "Credit score below acceptable threshold",
  },
  CREDIT_HISTORY: {
    code: "CREDIT_HISTORY",
    label: "Negative Credit History",
    category: "Credit",
    description: "Collections, charge-offs, or late payments",
  },
  CREDIT_INQUIRIES: {
    code: "CREDIT_INQUIRIES",
    label: "Excessive Credit Inquiries",
    category: "Credit",
    description: "Too many recent credit inquiries",
  },

  // Income-related (Plaid)
  INSUFFICIENT_INCOME: {
    code: "INSUFFICIENT_INCOME",
    label: "Insufficient Income",
    category: "Income",
    description: "Income below 3x rent requirement",
  },
  INCOME_VERIFICATION: {
    code: "INCOME_VERIFICATION",
    label: "Unable to Verify Income",
    category: "Income",
    description: "Income cannot be verified through Plaid",
  },
  INCOME_UNSTABLE: {
    code: "INCOME_UNSTABLE",
    label: "Income Instability",
    category: "Income",
    description: "Recent job changes or irregular income",
  },

  // ID/Verification-related
  ID_VERIFICATION_FAILED: {
    code: "ID_VERIFICATION_FAILED",
    label: "ID Verification Failed",
    category: "Identity",
    description: "Unable to verify identity or ID expired",
  },
  ID_MISMATCH: {
    code: "ID_MISMATCH",
    label: "Information Mismatch",
    category: "Identity",
    description: "Provided information does not match ID",
  },

  // Other
  CRIMINAL_HISTORY: {
    code: "CRIMINAL_HISTORY",
    label: "Criminal History",
    category: "Background",
    description: "Background check revealed disqualifying offenses",
  },
  EVICTION_HISTORY: {
    code: "EVICTION_HISTORY",
    label: "Eviction History",
    category: "History",
    description: "Previous evictions on record",
  },
  FRAUD_SUSPECTED: {
    code: "FRAUD_SUSPECTED",
    label: "Suspected Fraud",
    category: "Fraud",
    description: "Inconsistencies suggest potential fraud",
  },
};

export const petTemplate = {
  deposit: undefined,
  fee: "",
  monthly: undefined,
  name: "",
  type: "",
  color: "",
  age: "",
  license: "",
  rabies: "",
  breed: "",
  weight: "",
  license_city: "",
  owner_name: "",
  owner_email: "",
  veterinarian: "",
  veterinarian_telephone: "",
  emergency_contact: "",
  emergency_contact_cell: "",
  sex: "",
  neutered: false,
  declawed: false,
};

export const STATUS_OPTIONS = [
  { label: "Current applications", value: "pending" },
  { label: "Past applications", value: "past" },
];

export const DATE_FILTER_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "custom", label: "Custom Date" },
];

export const STATUS_FILTER_MAP: Record<string, string[]> = {
  pending: [
    "incomplete",
    "payment",
    "id-verification",
    "id-verification-failed",
    "income-verification",
    "submitted",
    "screened",
    "approved",
  ],
  past: ["denied", "archived", "completed"],
};